/**
 * 合作机构相关接口
 */
import { instance } from '../index';

export const getRoadshowList = async (data, config = {}) => {
  return await instance.post('/api/admin/cooperation/roadshow/list', data, config);
};

// 获取纪要列表
export const getSummaryList = async (data, config = {}) => {
  return await instance.get('/api/admin/cooperation/summary/querySummaryPage', data, config);
};

// 获取进门token信息
export const getJmMainLineToken = async (data, config = {}) => {
  return await instance.get('/api/admin/cooperation/common/mainLine/token', data, config);
};

// 免登陆接口（获取双token）
export const getAllAuthToken = async (data, config = {}) => {
  return await instance.post('/api/admin/user/nologin/token', data, config);
};
